// @ts-check
import React from 'react';
import AlertsHolderStore from 'Stores/alertsHolderStore';
import Alert from "Components/AlertsHolder/alert";
import { observer } from "mobx-react";
import IconsContainer from "Utils/IconsContainer";
import 'Styles/alertsHolder.scss'
import { animated, useTransition } from "react-spring";

/**
 * @param {{loggedIn: boolean}} props 
 */
const AlertsHolder = (props) => {
    let data = AlertsHolderStore.currentAlert ? [AlertsHolderStore.currentAlert] : [];

    const transitions = useTransition(data, {
        from: { top: '0px', opacity: 0 },
        enter: { top: '50px', opacity: 1 },
        leave: { top: '100px', opacity: 0 },
        keys: item => item.key
    });

    let currentAlert = transitions((style, item) => (
        <animated.div
            style={style}
            className='animated-alert-holder'>
            <Alert item={item} archive={false} />
        </animated.div>
    ));

    let showAlertsButton =
        (props.loggedIn === true && AlertsHolderStore.alertsArchive.length > 0) ?
            <div className={'open-alert-archive-button' + (AlertsHolderStore.archiveOpened ? ' opened' : '')}
                key='show-alerts-button'
                onClick={() => AlertsHolderStore.ChangeArchiveOpenState(!AlertsHolderStore.archiveOpened)}>
                <span>Уведомления</span>
                {IconsContainer.Get('ci-arrow-down')}
            </div>
            :
            '';

    let archivedAlerts = AlertsHolderStore.alertsArchive
        .map(item => (
            <Alert
                item={item}
                key={item.key}
                archive={true} />
        ));

    return (
        <div className={'alerts-holder' + ((AlertsHolderStore.archiveOpened === false) ? ' closed' : '')}>
            <div className='alerts-archive-list-with-clear-button'>
                <div className='alerts-archive-list-holder'>
                    {archivedAlerts}
                </div>
                <div className='button-container'>
                    <button className='clear-alerts-archive-button'
                        onClick={AlertsHolderStore.ClearAlertsArchive.bind(AlertsHolderStore)}>
                        Очистить все
                    </button>
                </div>
            </div>
            {showAlertsButton}
            {currentAlert}
        </div>
    )
}

export default observer(AlertsHolder);